module.exports = __webpack_public_path__ + "b2bf47c03de333227465a28dae0ba0c6.png";